module.exports = __webpack_public_path__ + "img/th.00fb266b.png";